// SalesCRM / ArchivedLeads — grid of archived leads with restore action.
import React, { Component } from "react";
import { Link } from "react-router-dom";
import HelperClass from "../../../../config/helperClass";
import { THEME_COLOR, THEME_TEXT_COLOR } from "../../../../config/config";
import dateFormat from "dateformat";
import {
  listLeadsGrid,
  listStages,
  restoreLead,
} from "../api/leads_api";
import { FALLBACK_STAGES } from "../api/leads_constants";

const auth = new HelperClass();

const DEFAULT_PAGE_SIZE = 25;

function StagePill({ stage_key, stages }) {
  const s = (stages || []).find(function (x) { return x.stage_key === stage_key; }) || { label: stage_key, color_hex: "#444", bg_hex: "#eee" };
  return (
    <span style={{
      display: "inline-block", padding: "3px 10px", borderRadius: 12,
      fontSize: 12, fontWeight: 600, color: s.color_hex, background: s.bg_hex,
    }}>{s.label}</span>
  );
}

function PriorityPill({ priority }) {
  var m = { high: { c: "#B02A2A", b: "#FEE2E2", l: "High" },
            med:  { c: "#C25A00", b: "#FDF0E5", l: "Medium" },
            low:  { c: "#1A7A4A", b: "#E6F4EC", l: "Low" } };
  var s = m[priority] || m.med;
  return (
    <span style={{
      display: "inline-block", padding: "2px 8px", borderRadius: 10,
      fontSize: 11, fontWeight: 600, color: s.c, background: s.b,
    }}>{s.l}</span>
  );
}

export default class ArchivedLeads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      stages: FALLBACK_STAGES,
      rows: [],
      total: 0,
      page: 1,
      page_size: DEFAULT_PAGE_SIZE,
      search: "",
      errorMessage: "",
      restoringId: null,
      successMessage: "",
      errorMessage: "",
    };
  }

  componentDidMount() {
    this.loadStages();
    this.loadGrid();
  }

  componentWillUnmount() {
    if (this._searchTimer) clearTimeout(this._searchTimer);
  }

  loadStages = async () => {
    const r = await listStages(auth.getAccount(), auth.getToken());
    if (r && r.data && r.data.status === 200) {
      this.setState({ stages: r.data.data || FALLBACK_STAGES });
    }
  };

  loadGrid = async () => {
    const { page, page_size, search } = this.state;
    this.setState({ loading: true, errorMessage: "" });
    try {
      const r = await listLeadsGrid(auth.getAccount(), auth.getToken(), {
        show_archived: true,
        page, page_size,
        search: search || undefined,
        sort_by: "created_at", sort_dir: "DESC",
      });
      if (!r || !r.data) { this.setState({ loading: false, errorMessage: "Network error" }); return; }
      if (r.data.status !== 200) { this.setState({ loading: false, errorMessage: r.data.message || "Failed to load" }); return; }
      this.setState({
        loading: false,
        rows: (r.data.data && r.data.data.rows) ? r.data.data.rows : [],
        total: (r.data.data && r.data.data.total) ? r.data.data.total : 0,
      });
    } catch (e) {
      this.setState({ loading: false, errorMessage: "Network error" });
    }
  };

  doRestore = async (lead) => {
    this.setState({ restoringId: lead.id });
    const r = await restoreLead(auth.getAccount(), auth.getToken(), lead.id);
    this.setState({ restoringId: null });
    if (r && r.data && r.data.status === 200) {
      this.setState({ successMessage: (lead.company || "Lead") + " restored to pipeline.", errorMessage: "" });
      this.loadGrid();
    } else {
      this.setState({ errorMessage: "Restore failed. Please try again.", successMessage: "" });
    }
  };

  changePage = (delta) => {
    const { page, page_size, total } = this.state;
    const maxPage = Math.max(1, Math.ceil(total / page_size));
    const next = page + delta;
    if (next < 1 || next > maxPage) return;
    this.setState({ page: next }, this.loadGrid);
  };

  onSearchChange = (e) => {
    const value = e.target.value;
    this.setState({ search: value });
    if (this._searchTimer) clearTimeout(this._searchTimer);
    this._searchTimer = setTimeout(() => {
      this.setState({ page: 1 }, this.loadGrid);
    }, 400);
  };

  onSearchSubmit = (e) => {
    e.preventDefault();
    if (this._searchTimer) clearTimeout(this._searchTimer);
    this.setState({ page: 1 }, this.loadGrid);
  };

  onSearchClear = () => {
    if (this._searchTimer) clearTimeout(this._searchTimer);
    this.setState({ search: "", page: 1 }, this.loadGrid);
  };

  formatDate(v) {
    if (!v) return "—";
    try { return dateFormat(new Date(v), "mmm d, yyyy"); } catch (e) { return v; }
  }

  render() {
    const { loading, stages, rows, total, page, page_size, search, errorMessage, successMessage, restoringId } = this.state;
    const maxPage = Math.max(1, Math.ceil(total / page_size));

    return (
      <div className="nk-content">
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">

          {successMessage !== "" ? (
            <div className="example-alert">
              <div className="alert alert-pro alert-success">
                <div className="alert-text">
                  <h4>Success</h4>
                  <p>{successMessage}</p>
                </div>
              </div>
            </div>
          ) : null}
          {errorMessage !== "" && !loading ? (
            <div className="example-alert">
              <div className="alert alert-pro alert-danger">
                <div className="alert-text">
                  <h4>Error</h4>
                  <p>{errorMessage}</p>
                </div>
              </div>
            </div>
          ) : null}

          <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
              <div className="nk-block-head-content">
                <h3 className="nk-block-title page-title">Archived Leads</h3>
                <div className="nk-block-des text-soft">
                  <p>Leads removed from the active pipeline — restore to bring them back</p>
                </div>
              </div>
              <div className="nk-block-head-content d-flex" style={{ gap: 8, flexWrap: "wrap" }}>
                <Link to="/crm_leads" className="btn btn-outline-light btn-sm">
                  <em className="icon ni ni-arrow-left" style={{ marginRight: 4 }}></em> Back to Pipeline
                </Link>
              </div>
            </div>
          </div>

          <div className="nk-block">
            <div className="card card-bordered card-stretch">

              {/* Search bar */}
              <div className="card-inner" style={{ paddingBottom: 12 }}>
                <form onSubmit={this.onSearchSubmit} style={{ display: "flex", gap: 8, maxWidth: 380 }}>
                  <div style={{ position: "relative", flex: 1 }}>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search archived leads…"
                      value={search}
                      onChange={this.onSearchChange}
                      style={{ width: "100%", paddingRight: search ? 28 : 10 }}
                    />
                    {search && (
                      <button
                        type="button"
                        onClick={this.onSearchClear}
                        title="Clear search"
                        style={{ position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", padding: 0, color: "#9ca3af", fontSize: 14 }}
                      >
                        <em className="icon ni ni-cross"></em>
                      </button>
                    )}
                  </div>
                </form>
              </div>

              {errorMessage ? (
                <div className="card-inner"><div className="alert alert-warning">{errorMessage}</div></div>
              ) : null}

              <div className="card-inner p-0">
                <table className="table table-tranx">
                  <thead className="tb-tnx-head">
                    <tr className="tb-tnx-item">
                      <th className="tb-tnx-info">Lead ID</th>
                      <th className="tb-tnx-info">Company</th>
                      <th className="tb-tnx-info">Contact</th>
                      <th className="tb-tnx-info">Stage</th>
                      <th className="tb-tnx-info">Value</th>
                      <th className="tb-tnx-info">Priority</th>
                      <th className="tb-tnx-info">Archived On</th>
                      <th className="tb-tnx-info" style={{ textAlign: "right" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr><td colSpan={8} style={{ textAlign: "center", padding: 24 }}>Loading…</td></tr>
                    ) : rows.length === 0 ? (
                      <tr>
                        <td colSpan={8} style={{ textAlign: "center", padding: 32, color: "#888" }}>
                          No archived leads found.
                        </td>
                      </tr>
                    ) : rows.map((r) => (
                      <tr key={r.id} className="tb-tnx-item" style={{ opacity: restoringId === r.id ? 0.5 : 1 }}>
                        <td className="tb-tnx-info">
                          <Link
                            to={"/crm_lead_detail/" + r.lead_uid}
                            style={{ fontWeight: 600, color: "#1c5bde", textDecoration: "none" }}
                            onMouseEnter={function(e) { e.target.style.textDecoration = "underline"; }}
                            onMouseLeave={function(e) { e.target.style.textDecoration = "none"; }}
                          >
                            {r.lead_uid}
                          </Link>
                        </td>
                        <td className="tb-tnx-info">
                          <div style={{ fontWeight: 600 }}>{r.company}</div>
                        </td>
                        <td className="tb-tnx-info">
                          <div>{r.contact_name || "—"}</div>
                          <div style={{ fontSize: 12, color: "#666" }}>{r.email || ""}</div>
                        </td>
                        <td className="tb-tnx-info">
                          <StagePill stage_key={r.stage_key} stages={stages} />
                        </td>
                        <td className="tb-tnx-info">
                          {"$" + (Number(r.deal_value) || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}
                        </td>
                        <td className="tb-tnx-info">
                          <PriorityPill priority={r.priority} />
                        </td>
                        <td className="tb-tnx-info">{this.formatDate(r.updated_at)}</td>
                        <td className="tb-tnx-info" style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                          <button
                            type="button"
                            disabled={restoringId === r.id}
                            onClick={() => this.doRestore(r)}
                            style={{
                              display: "inline-flex", alignItems: "center", gap: 5,
                              padding: "4px 12px", borderRadius: 6, fontSize: 12, fontWeight: 600,
                              border: "1px solid " + THEME_COLOR,
                              background: "#fff", color: THEME_COLOR,
                              cursor: restoringId === r.id ? "not-allowed" : "pointer",
                              transition: "background .15s,color .15s",
                            }}
                            onMouseEnter={function(e) {
                              e.currentTarget.style.background = THEME_COLOR;
                              e.currentTarget.style.color = "#fff";
                            }}
                            onMouseLeave={function(e) {
                              e.currentTarget.style.background = "#fff";
                              e.currentTarget.style.color = THEME_COLOR;
                            }}
                          >
                            <em className="icon ni ni-undo" style={{ fontSize: 13 }}></em>
                            {restoringId === r.id ? "Restoring…" : "Restore"}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="card-inner">
                <div className="nk-block-between-md g-3">
                  <div className="g">
                    <span style={{ color: "#666", fontSize: 13 }}>
                      Showing {rows.length === 0 ? 0 : (page - 1) * page_size + 1}–{(page - 1) * page_size + rows.length} of {total}
                    </span>
                  </div>
                  <div className="g">
                    <ul className="pagination justify-content-center justify-content-md-end">
                      <li className={"page-item " + (page <= 1 ? "disabled" : "")}>
                        <button type="button" className="page-link" onClick={() => this.changePage(-1)}>Prev</button>
                      </li>
                      <li className="page-item active"><span className="page-link">{page} / {maxPage}</span></li>
                      <li className={"page-item " + (page >= maxPage ? "disabled" : "")}>
                        <button type="button" className="page-link" onClick={() => this.changePage(1)}>Next</button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    );
  }
}
